import { render, staticRenderFns } from "./unsubmit.vue?vue&type=template&id=5148f4d0&scoped=true&"
import script from "./unsubmit.vue?vue&type=script&lang=js&"
export * from "./unsubmit.vue?vue&type=script&lang=js&"
import style0 from "./unsubmit.vue?vue&type=style&index=0&id=5148f4d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5148f4d0",
  null
  
)

export default component.exports